export class SapJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "pipelineId",
            "baseName": "pipelineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SapIngestionMode",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SapJobStatus",
            "format": ""
        },
        {
            "name": "rowsExtracted",
            "baseName": "rowsExtracted",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytesExtracted",
            "baseName": "bytesExtracted",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SapJob.attributeTypeMap;
    }
    constructor() {
    }
}
